var map = {
	"./sad_illustration.svg": 2446,
	"./sad_lights.svg": 1419,
	"./sad_sensor.svg": 7046,
	"./sad_sensors.svg": 969,
	"./sad_switch.svg": 8448,
	"./sad_switches.svg": 9156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2656;